import { useState, useEffect } from 'react';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import attachmentEngine from './AttachmentEngine';
import attachmentStripHandler from './AttachmentStripHandler';

/**
 * useAttachments — observer hook for AttachmentEngine and AttachmentStripHandler.
 * Subscribes to ComponentNotifier and filters on panelId so each panel only
 * repaints when its own data changes.
 * @param {string} [panelId='default']
 * @returns {{ documents: object[], collapsed: boolean, showUpload: boolean }}
 */
export function useAttachments(panelId = 'default') {
    const [, forceRepaint] = useState(0);

    useEffect(() => {
        const handleData = (e) => {
            if (e.data?.panelId !== panelId) return;
            forceRepaint((n) => n + 1);
        };

        const handleStrip = () => {
            forceRepaint((n) => n + 1);
        };

        const unsubData  = componentNotifier.subscribe('dataChanged', handleData);
        const unsubStrip = componentNotifier.subscribe('stripStateChanged', handleStrip);

        return () => {
            unsubData();
            unsubStrip();
        };
    }, [panelId]);

    return {
        documents: attachmentEngine.getDocuments(panelId),
        collapsed: attachmentStripHandler.collapsed,
        showUpload: attachmentStripHandler.showUpload,
    };
}
